var styles = {
  "ChartDimensions": "_ChartDimensions_qgx6z_1",
  "Chart": "_Chart_qgx6z_1"
};

export { styles as default };
